import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const SuiteHeader = () => import(/* webpackChunkName: "4-feat-suiteheader" */ './SuiteHeaderContainer');

export default lazyLoadOnRender({ loader: SuiteHeader });
